/** null = nothing scoped, so the agent searches every connector. Array = the user's scope. */
export type EnabledMcpSectionIds = string[] | null

export function resolveEnabledMcpSectionIds(
	enabled: EnabledMcpSectionIds,
	availableIds: readonly string[],
): string[] {
	if (enabled === null) return []
	const available = new Set(availableIds)
	return enabled.filter((id) => available.has(id))
}

export function mcpTriggerLabel(selectedTitles: readonly string[]): string {
	if (selectedTitles.length === 0) return "MCP"
	if (selectedTitles.length === 1) return selectedTitles[0]!
	return `${selectedTitles.length} MCP servers`
}

export function nextMcpSelection(
	selectedIds: readonly string[],
	id: string,
): string[] {
	if (selectedIds.includes(id)) {
		return selectedIds.filter((selected) => selected !== id)
	}
	return [...selectedIds, id]
}

// An empty scope is sent as undefined so the server searches everything, rather
// than as [] which would read as a scope that matches nothing.
export function mcpSectionIdsForRequest(
	enabled: EnabledMcpSectionIds,
	availableIds: readonly string[],
): string[] | undefined {
	const resolved = resolveEnabledMcpSectionIds(enabled, availableIds)
	return resolved.length === 0 ? undefined : resolved
}
